
import { ReactNode } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import { Dialog } from "@/components/ui/dialog";

interface ModalFormProps {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  children: ReactNode;
  submitText?: string;
  cancelText?: string;
  className?: string;
  submitDisabled?: boolean;
}

export const ModalForm = ({
  title,
  isOpen,
  onClose,
  onSubmit,
  children,
  submitText = "Add",
  cancelText = "Cancel",
  className,
  submitDisabled = false,
}: ModalFormProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 animate-fade-in">
      <div 
        className={cn(
          "bg-white rounded-lg w-full max-w-3xl mx-4 max-h-[95vh] overflow-y-auto animate-slide-in",
          className
        )}
      >
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
          <h2 className="text-xl font-semibold">{title}</h2>
          <button 
            type="button" 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <form onSubmit={onSubmit}>
          <div className="p-4 space-y-4">
            {children}
          </div>
          
          <div className="flex justify-end p-4 border-t gap-3 sticky bottom-0 bg-white z-10">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
            >
              {cancelText}
            </button>
            <button
              type="submit"
              disabled={submitDisabled}
              className={cn(
                "px-4 py-2 text-sm font-medium text-white bg-digger-blue rounded-md transition-colors",
                submitDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-digger-blue-light"
              )}
            >
              {submitText}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
